import React, { useEffect, useMemo, useState, useContext } from 'react';
import ManagementHeaderNav from '../../components/HeadersNav/ManagementHeaderNav';
import { Box, CircularProgress, Grid, MenuItem, Paper, TextField, Typography , Button } from '@mui/material';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import { setAssignmentListDDL, setCallbackMaxNumberDDL } from '../../store/ddlReducer';
import { useSelector, useDispatch } from 'react-redux';
import ApiService from '../../functions/apiService';
import { toast } from 'react-toastify';
import { useForm } from 'react-hook-form';
import MyTable from '../../components/Schedule/MyTable';
import PaginationComponent from '../../components/Pagination/Pagination';
import moment from 'moment';
import { getGridStringOperators } from '@mui/x-data-grid';
import { formateDate, varFormatTime } from '../../utils/helperFunctions';
import Timer from './Timer';
import AuthContext from '../../context/AuthContext';
import CollapseComponent from '../../components/Schedule/CollapseComponent';
import { TranslatableInputsTabContent } from 'react-admin';

export default function CallBack() {
  const { user } = useContext(AuthContext)
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [resData, setResData] = useState({});
  const [tableLoading, setTableLoading] = useState(false);
  let AssignmentListDDL = useSelector((state) => state.ddlReducer.AssignmentListDDL)
  let CallbackMaxNumberDDL = useSelector((state) => state.ddlReducer.CallbackMaxNumberDDL)
	const [timerType, setTimerType] = useState('Seconds');
	const [timer, setTimer] = useState(5);
	

  const [filter, setFilter] = useState({
    LogTime: moment(new Date()).format("DD-MM-YYYY"),
    LogEmpCode: "",
    LogType: "",
    LogSeverity: "",
    LogEmpText: "",
    field: "",
    type: "",
  });

  const [columns, setColumns] = useState([
    {
      field: "Log_Time",
      headerName: "Timestamp",
      flex: 1,
      minWidth: 200,
      hideable: false,
      // sort: "asc",
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
      valueGetter: (params) => varFormatTime(params.row.Create_Time, user?.Time_Format)
    },
    {
      field: "CreatedBy",
      headerName: "Created By",
      flex: 1,
      minWidth: 220,
      // sort: "asc",
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
      valueGetter: (params) =>
        params.row?.creating_emp?.fullName
    },
    {
      field: "AssignmentText",
      headerName: "Assignment",
      flex: 1,
      minWidth: 120,
      // sort: "asc",
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
    {
      field: "Assignment_Text",
      headerName: "Call #",
      flex: 1,
      minWidth: 120,
      // sort: "asc",
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
    {
      field: "FilledEmpName",
      headerName: "Filled By",
      flex: 1,
      minWidth: 200,
      // sort: "asc",
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
    {
      field: "StatusText",
      headerName: "Status",
      flex: 1,
      minWidth: 200,
      // sort: "asc",
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
    {
      field: "ClosedByEmpName",
      headerName: "Closed By",
      flex: 1,
      minWidth: 200,
      // sort: "asc",
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
  ]);

  const [columns2, setColumns2] = useState([
    {
      field: "fullName",
      headerName: "name",
      flex: 1,
      minWidth: 200,
      hideable: false,
      // sort: "asc",
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
      valueGetter: (params) => params.row.employee?.fullName
    },
    {
      field: "Hours",
      headerName: "Hours",
      flex: 1,
      minWidth: 200,
      // sort: "asc",
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      )
    },
    {
      field: "StatusText",
      headerName: "Status",
      flex: 1,
      minWidth: 120,
      // sort: "asc",
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
    {
      field: "Timestamp",
      headerName: "Timestamp",
      flex: 1,
      minWidth: 120,
      // sort: "asc",
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
      valueGetter: (params) => varFormatTime(params.row.Create_Time, user?.Time_Format)
    },
  ]);

  const {
    register,
    formState: { errors, isValid },
    handleSubmit,
    setError,
    setValue,
    reset,
  } = useForm({});

  let nIntervId;
  let getJobData = () => {
    ApiService.get('/CallBack').then(({ data }) => {
      setLoading(false)
      if (data.data.batch && data.data.batch.length > 0) {
        setTimer(data.data.timer)
      } else {
        if (nIntervId) {
          clearInterval(nIntervId)
        }
      }
      setResData(data.data)
    }).catch(() => {
      setLoading(false)
      toast.error("Error")
    });
  }

  const loadData = (page = 1) => {
    setLoading(true)
    ApiService.get('/CallBack', { page: page }, 'CallBack').then(({ data }) => {
      setLoading(false)
      if (data.data.batch && data.data.batch.length > 0) {
        setTimer(data.data.timer)
        if (!nIntervId) {
          nIntervId = setInterval(getJobData, Number(data.data.timer) * 1000);
        }
      }
      setResData(data.data)
    }).catch(() => {
      setLoading(false)
      toast.error("Error")
    })
  }

  const loadDropDowns = () => {
    ApiService.get('/getCallbackMaxNumberDDL', {}, 'getCallbackMaxNumberDDL').then(({ data }) => {
      dispatch(setCallbackMaxNumberDDL(data));
    }).catch(() => {
      toast.error("Error")
    })
    ApiService.get('/getAssignmentListDDL', {}, 'getAssignmentListDDL').then(({ data }) => {
      dispatch(setAssignmentListDDL(data));
    }).catch(() => {
      toast.error("Error")
    })
  }

  useEffect(() => {
    loadData();
    loadDropDowns()
    return () => {
      clearInterval(nIntervId)
    }
  }, [])

  let onSubmit = (body) => {
    ApiService.post('/postCallBack', body).then(() => {
      loadData();
    })
  }

  let setPaginationModel = (e) => {
    loadData(e.page + 1);
  };
  const PageChanged = (e, page) => {
    loadData(page);
  };

  const handleSortModelChange = (value) => {
    console.log("value", value);
    // setFilter((pre) => {
    //     return {
    //         ...pre,
    //         field: value.length == 0 ? filter.field : value[0].field,
    //         // type: value.length == 0 ? filter.type : value[0].sort,
    //         type: value.length == 0 ? [] : value[0].sort,
    //     };
    // });
  };

  const AcceptCallBack = () => {
    ApiService.post('/CompleteCallBack', { ShiftDate: resData.shift.Shift_Date, ShiftNumber: resData.shift.Shift_Number }).then(() => {
      loadData();
    })
  }

  const CloseCallBack = () => {
    ApiService.post('/CloseCallBack', { ShiftDate: resData.shift.Shift_Date, ShiftNumber: resData.shift.Shift_Number }).then(() => {
      loadData();
    })
  }


  return <>
    <ManagementHeaderNav />
		{resData.view == 'table' && 
			<Paper className='p-3' style={{ marginTop: "1rem", maxWidth: '94vw', overflowX: 'auto', }}>
				<Typography variant="h6">Create CallBack</Typography>
				<form onSubmit={handleSubmit(onSubmit)}>
					<Grid container spacing={2} className='mb-1'>
						<Grid item xs={6} md={2} className='mt-2'>
							<label style={{ fontSize: '14px' }}>Callback</label>
							<TextField
								{...register("CallBack", { required: "CallBack is required" })}
								className='mt-1 w-100' color='secondary' variant="outlined"
								select size='small'
								InputProps={{
									sx: {
										height: '48px',
										fontSize: '14px'
									}
								}}
							>
								{CallbackMaxNumberDDL.map(item => {
									return <MenuItem key={item} value={item} >{item} </MenuItem>
								})}
							</TextField>
						</Grid>
						<Grid item xs={6} md={2} className='mt-2'>
							<label style={{ fontSize: '14px' }}>Assignment</label>
							<TextField
								{...register("Assignment", { required: "Assignment is required" })}
								className='mt-1 w-100' color='secondary' variant="outlined"
								select size='small'
								InputProps={{
									sx: {
										height: '48px',
										fontSize: '14px'
									}
								}}
							>
								{AssignmentListDDL.map(item => {
									return <MenuItem key={item.SO_Value} value={item.SO_Value}>{item.SO_Desc} </MenuItem>
								})}

							</TextField>
						</Grid>
						<Grid item xs={6} md={2} className='mt-2'>
							<label style={{ fontSize: '14px' }}>Call #</label>
							<TextField size='small'
								{...register("Call", { required: "Call is required" })}
								className='mt-1 w-100' color='secondary' variant="outlined"
								placeholder='24-0000'
								InputProps={{
									sx: {
										height: '48px',
										fontSize: '14px'
									}
								}}
							>
							</TextField>
						</Grid>
						<Grid item xs={12} md={4.5}>
							<label className="h6 text-black" style={{ fontSize: '14px' }}>Time interval</label>
							<div style={{display:'flex'}}>
								<div className="input-group" style={{ marginRight: '10px', maxHeight: '34px', marginTop: '8px' }}>
									<input type="text" className="form-control shadow-none"
										style={{ maxWidth: '50px', fontSize: '12px' }}
										value={timer}
										onChange={(e) => setTimer(Number(e.target.value))} 
									/>
									<select className="form-select shadow-none" style={{ fontSize: '12px' , cursor:'pointer' , maxWidth:'100px' }}
										value={timerType}
										onChange={(e) => setTimerType(e.target.value)}>
										<option value="Seconds">Seconds</option>
										<option value="Minutes">Minutes</option>
									</select>
								</div>
								<Box sx={{display:'flex' , marginTop:'4px'}}>
									<Button className='mx-1 my-1' style={{ fontSize: '12px' , padding:'0px 10px' }} variant="outlined" color='secondary' onClick={(e) => { setTimer(10); setTimerType('Minutes') }}>10 min</Button>
									<Button className='mx-1 my-1' style={{ fontSize: '12px' , padding:'0px 10px' }} variant="outlined" color='secondary' onClick={(e) => { setTimer(5); setTimerType('Minutes') }}>5 min</Button>
									<Button className='mx-1 my-1' style={{ fontSize: '12px' , padding:'0px 10px' }} variant="outlined" color='secondary' onClick={(e) => { setTimer(2); setTimerType('Minutes') }}>2 min</Button>
									<Button className='mx-1 my-1' style={{ fontSize: '12px' , padding:'0px 10px' }} variant="outlined" color='secondary' onClick={(e) => { setTimer(1); setTimerType('Minutes') }}>Last Minute</Button>
								</Box>
							</div>
						</Grid>
						<Grid item xs={6} md={1.5}>
							<ButtonTheme disabled={saving || !isValid} type='submit' variant="filled" color='primary' className='px-4' style={{ marginTop: '38px' }}>
								Call Back
							</ButtonTheme>
						</Grid>
					</Grid>
				</form>
			</Paper>
		}

		{resData.view == 'table' &&
			<Paper className='p-3 mt-3'>
				{loading ?
					<Box className="w-100 h-100 d-flex justify-content-center align-items-center">
						<CircularProgress />
					</Box> 
					: 
					<>
						<Box className='mb-3'>
							{/* <MyTable
								checkboxSelection={false}
								useTopFilter={false}
								columns={columns}
								lastPage={resData.data.last_page}
								rows={resData.data.data}
								perPage={resData.data.per_page}
								paginationMode="server"
								rowCount={resData.data.total}
								onPaginationModelChange={setPaginationModel}
								onePageOption={true}
								loading={tableLoading}
								hideFooter={true}
								sortType={true}
								sortMode={{
									field: filter?.field,
									sort: filter?.type,
								}}
								handleSortModelChange={handleSortModelChange}
							/> */}
							<CollapseComponent
								name={"CallBack History"}
								rows={resData.data.data}
								columns={columns}
								hideFooter={true}
								useTopFilter={true}
								open={true}
								checkboxSelection={false}
							/>
						</Box>
						<PaginationComponent
							results={resData.data}
							pageChanged={PageChanged}
						/>
					</>
				}

			</Paper>
		}

		{resData.view == 'list' &&
			<Paper className='p-3 mt-4'>
				{loading ?
					<Box className="w-100 h-100 d-flex justify-content-center align-items-center">
						<CircularProgress />
					</Box> 
					: 
					<>
						<div style={{display:'flex' , justifyContent:'space-between'}}>
							<Typography variant="h6">Callback in Progress</Typography>
							<Button style={{ color: '#555555' }} onClick={CloseCallBack}>
								<img src="/images/back-button.svg" alt="icon" width='30px' height='30px' />
							</Button>
						</div>
						<div>
							<p>
								<strong>Callback initiated:</strong> {formateDate(resData.shift.Shift_Date)} ,{" "}
								<strong>Callback:</strong> {resData.shift.Detail_Text} ,{" "}
								<strong>Assignment:</strong> {resData.shift?.AssignmentText} ,{" "}
								<strong>Call #</strong> {resData.shift?.Assignment_Text}
							</p>
						</div>
						<p>Timer : <Timer seconds={timer} setSeconds={setTimer} /> </p>
						<CollapseComponent
							checkboxSelection={true}
							useTopFilter={false}
							name={"Offered"}
							open={true}
							columns={columns2}
							rows={resData.data}
							loading={tableLoading}
							hideFooter={true}
						/>
						<ButtonTheme disabled={!resData.acceptBtn} onClick={AcceptCallBack} type='button' variant="filled" color='primary' className='px-5 my-3'>
							Accept
						</ButtonTheme>
						<CollapseComponent
							checkboxSelection={false}
							useTopFilter={false}
							name={"Employees"}
							open={true}
							columns={columns2}
							rows={resData.data}
							loading={tableLoading}
							hideFooter={true}
						/>
					</>
				}
		</Paper>
		}
  </>
}
